import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザを追加する
 *
 * @param {String} orgcode 組織コード
 * @param {Object} user ユーザ情報
 * @returns {Response} レスポンスデータ
 */
export function newUser (orgcode, user) {
  return request.post(`/org/${orgcode}/users`, user, {
    validateStatus: (status) => [
      http.Created,
      http.Conflict
    ].includes(status)
  })
}
